<template>
  <div class="flex h-full flex-col">
    <TillRouteTabs class="shrink-0" />

    <div class="flex-1 overflow-y-auto">
      <RouterView />
    </div>

    <ShoppingCartDrawer class="shrink-0" />
  </div>
</template>

<script setup>
import { prefetchProducts } from "@/services/products/listProducts"
import { prefetchCategories } from "@/services/categories/listCategories"

prefetchProducts()
prefetchCategories()
</script>
